import { render, staticRenderFns } from "./HeroBannerBlock.vue?vue&type=template&id=a1b833f0&scoped=true&"
import script from "./HeroBannerBlock.vue?vue&type=script&lang=ts&"
export * from "./HeroBannerBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HeroBannerBlock.vue?vue&type=style&index=0&id=a1b833f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b833f0",
  null
  
)

export default component.exports